<template>
  <div>
  <Card>
      <Row>
        <i-col span="24">
          <Form ref="searchForm" inline :model="searchForm" :label-width="120" @submit.native.prevent>
            <FormItem label="项目名/项目负责人" prop="name">
              <i-input v-model="searchForm.name" placeholder="请输入项目名/项目负责人"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getProjectsList()">搜索</Button>
              <Button @click="searchReset" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
       </Row>
      <tables search-place="top" v-model="tableData" :columns="columns" @on-sort-change="changeSort"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getProjectsList"></page>
        </div>
     </Row>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { getList } from '@/api/project'
// import { forEach } from '@/libs/tools'
export default {
  name: 'ProjectList',
  components: {
    Tables
  },
  data () {
    // const validateDevelopers = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error('开发人员不能为空 !'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      count: 1,
      size: 10,
      page: 1,
      ordering: null,
      is_superuser: false,
      columns: [
        { title: 'ID', key: 'id', align: 'center', sortable: 'custom', minWidth: 80 },
        { title: '项目名', key: 'name', align: 'center', minWidth: 100 },
        { title: '项目英文名', key: 'name_en', align: 'center', minWidth: 100 },
        { title: '项目负责人', key: 'masters', align: 'center', minWidth: 100 },
        {
          title: '操作',
          align: 'center',
          minWidth: 140,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$router.push({name: 'ProjectDetail', query: {id: params.row.id}})
                    // this.$router.push({path: '/Project/ProjectDetail', query: {id: params.row.id}})
                  }
                }
              }, '详情'),
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small',
                  disabled: !this.$store.state.user.superuser
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$router.push({name: 'ProjectEdit', query: {id: params.row.id}})
                  }
                }
              }, '编辑')
            ])
          }
        }
      ],
      tableDataTmp: [],
      tableData: [],
      searchForm: {
        name: null
      },
      listStyle: {
        width: '250px',
        height: '300px'
      }
    }
  },
  methods: {
    getProjectsList (value = 1) {
      this.page = value
      let params = {
        page: this.page,
        ordering: this.ordering,
        search: this.searchForm.name
      }
      getList(params).then(res => {
        this.tableData = res.data.results
        this.tableData.map((item, index) => {
          item.masters = item.masters ? item.masters.join(',') : ''
        })
        this.count = res.data.count
      })
    },
    changeSort (column) {
      if (column.key === 'id') {
        if (column.order === 'asc') {
          this.ordering = 'id'
        } else {
          this.ordering = '-id'
        }
      }
      this.getProjectsList()
    },
    searchReset () {
      this.searchForm.name = null
    }
  },
  mounted: function () {
    this.getProjectsList()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
